import { Product } from '@shared/components/ui/Product';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { BatchSelect } from '@modules/Batches/components/BatchSelect';

interface ProductItemProps {
  product: {
    id: string;
    name: string;
    code: string;
    image: string;
    qty: number;
  };
  scannedQuantity: number;
  isFlashing: boolean;
  batchId: number | null;
  onBatchChange: (productId: string, batchId: number | null) => void;
}

export const ProductItem = ({ product, scannedQuantity, isFlashing, batchId, onBatchChange }: ProductItemProps) => {
  const isComplete = scannedQuantity >= product.qty;
  const hasExcess = scannedQuantity > product.qty;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <Product id={parseInt(product.id)} src={product.image} name={product.name} code={product.code} />

        <div
          className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs transition-colors duration-300 ${
            isFlashing
              ? 'text-white'
              : hasExcess
                ? 'bg-bg-warning text-warning'
                : isComplete
                  ? 'bg-bg-success text-success'
                  : 'bg-card-border light:bg-[#3D4A5D] light:text-white'
          }`}
          style={isFlashing ? { backgroundColor: '#00A900' } : {}}
        >
          {hasExcess && !isFlashing && <FontAwesomeIcon icon={faTriangleExclamation} className="w-3 h-3" />}
          {isComplete && !hasExcess && !isFlashing && <FontAwesomeIcon icon={faCircleCheck} className="w-3 h-3" />}
          <span className="whitespace-nowrap">
            {scannedQuantity} / {product.qty}
          </span>
        </div>
      </div>

      <BatchSelect productId={parseInt(product.id)} value={batchId} onChange={(id) => onBatchChange(product.id, id)} />
    </div>
  );
};
